export default () => ({
  container: {
    maxWidth: 1200,
    margin: 'auto',
  },
});
